import { render, staticRenderFns } from "./Clinics.vue?vue&type=template&id=3f3b7daa&scoped=true&"
import script from "./Clinics.vue?vue&type=script&lang=js&"
export * from "./Clinics.vue?vue&type=script&lang=js&"
import style0 from "./Clinics.vue?vue&type=style&index=0&id=3f3b7daa&prod&lang=css&"
import style1 from "./Clinics.vue?vue&type=style&index=1&id=3f3b7daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b7daa",
  null
  
)

export default component.exports